const doc = [({"en":({"models":({"option_position":({"coordinates_already_taken":"The coordinates are already taken"})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;